module.exports = __webpack_public_path__ + "images/platform-snaps.png";